<template>
    <el-scrollbar wrap-class="scrollbar-wrapper">
        <router-link to="/">
            <li class="el-menu-item logo is-text-align-center">
                <svg-icon icon-class="logo" />
            </li>
        </router-link>
        <carton />
        <h2 class="el-menu-item is-text-align-center">
            {{ prenom }}
            {{ name }}
        </h2>
        <div class=" is-text-align-center">
            <el-button
                type="success"
                class="button"
                @click.native.prevent="logout"
            >
                Déconnexion
            </el-button>
            <el-button
                type="success"
                class="button"
                @click.native.prevent="contacteznous"
            >
                Contact
            </el-button>
        </div>
        <!--
        <div class=" is-text-align-center">
            <el-button
                type="success"
                class="button"
                @click.native.prevent="dialogCharteVisible = true"
            >
                Notre Charte
            </el-button>
        </div>
        
        -->
        <div class=" is-text-align-center">
            <el-button
                v-if="isadmin"
                type="success"
                class="button"
                icon="el-icon-setting"
                @click.native.prevent="$router.push('/')"
            >
                Admin
            </el-button>
        </div>
        <el-dialog
            title="Contact"
            :visible.sync="dialogContactVisible"
            :modal-append-to-body="true"
            :append-to-body="true"
            v-loading="loading"
        >
            <div class="form-container">
                <el-form ref="contactForm" style="max-width: 600px;">
                    <h3>
                        {{ prenom }}
                        {{ name }},<br />
                    </h3>
                    <span>
                        <b>Email :</b> {{ email }} <br />
                        <template v-if="panier">
                            <b>Adresse de livraison :</b>
                            {{ panier.livraison_adresse_label }} <br />
                            <b>Adresse de Facturation :</b>
                            {{
                                panier.facturation_adresse_label
                                    ? panier.facturation_adresse_label
                                    : "comme livraison"
                            }}
                            <br />
                        </template>
                    </span>
                    <p>
                        {{ options["allocations_formulairecontact"] }}
                    </p>
                    <el-form-item label="Message" prop="message">
                        <el-input type="textarea" v-model="message" :rows="5" />
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogContactVisible = false">
                        Annuler
                    </el-button>
                    <el-button type="primary" @click="sendContact()">
                        Envoyer
                    </el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            title=" "
            :visible.sync="dialogCharteVisible"
            :modal-append-to-body="true"
            :append-to-body="true"
            class="charte"
        >
            <div v-html="options['allocations_charte']" />
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogCharteVisible = false"
                    >Fermer</el-button
                >
            </div>
        </el-dialog>
    </el-scrollbar>
</template>

<script>
import carton from "@/components/Carton";
import { mapState } from "vuex";
import { findoptions } from "@/utils/options";
import Resource from "@/api/resource";
const userResource = new Resource("users");

export default {
    components: {
        carton
    },
    computed: {
        ...mapState({
            isadmin: state => state.user.isadmin,
            name: state => state.user.name,
            email: state => state.user.email,
            id: state => state.user.id,
            prenom: state => state.user.prenom,
            //penser à le mettre en prop pour carton
            panier: state => state.user.panier
        })
    },
    data() {
        return {
            dialogContactVisible: false,
            dialogCharteVisible: false,
            message: "",
            loading: false,
            options: {
                allocations_formulairecontact: "",
                allocations_charte: ""
            }
        };
    },
    created() {
        findoptions(this.options, this);
    },
    methods: {
        callbackoptions(slug, data) {
            this.options[slug] = data;
        },
        async logout() {
            await this.$store.dispatch("user/logout");
            this.$router.push(`/login?redirect=${this.$route.fullPath}`);
        },
        contacteznous() {
            console.log("contacteznous");
            this.dialogContactVisible = true;
        },
        sendContact() {
            console.log("contacteznous");
            this.loading = true;
            userResource
                .update(this.id, { message: this.message })
                .then(response => {
                    console.log(response);
                    this.$message({
                        message: response.message,
                        type: "success",
                        duration: 5 * 1000
                    });
                    this.loading = false;
                    this.dialogContactVisible = false;
                    this.message = "";
                })
                .catch(error => {
                    console.log(error);
                    this.$message({
                        message: "Erreur dans l'envoi",
                        type: "error",
                        duration: 3 * 1000
                    });
                    this.loading = false;
                });
        }
    }
};
</script>

<style lang="sass">
.el-menu-vertical:not(.el-menu--collapse)
    min-height: 100vh
</style>
